export default {
    setActiveDropdown(state, id) {
        state.activeDropdown = id;
    },
    closeAllDropdowns(state) {
        state.activeDropdown = null;
    }
} 